import axios from './localAxios';
import { CreateQuizResponse } from './responses';

export type QuizUrl = ({ quizId }?: { quizId?: number | string }) => string;
export type DeleteQuizUrl = QuizUrl;

interface LoadQuizParams {
  socNumber: string;
  quizUrl: QuizUrl;
}

async function loadQuiz({ socNumber, quizUrl }: LoadQuizParams) {
  const url = quizUrl();
  const response = await axios.get<CreateQuizResponse>(url, {
    params: { soc: socNumber, t: new Date().getTime() },
  });
  return response.data;
}

interface GetQuizByIdParams {
  quizId: number;
  quizUrl: QuizUrl;
}

async function getQuizById({ quizId, quizUrl }: GetQuizByIdParams) {
  const url = quizUrl({ quizId });
  const response = await axios.get<CreateQuizResponse>(url, {
    params: { t: new Date().getTime() },
  });
  return response.data;
}

interface DeleteQuizParams {
  quizId?: number | string;
  deleteQuizUrl: DeleteQuizUrl;
}

async function deleteQuiz({ quizId, deleteQuizUrl }: DeleteQuizParams) {
  const url = deleteQuizUrl({ quizId });
  const response = await axios.delete<unknown>(url);
  return response.data;
}

export type UpdateQuizResponse = {
  createdById: number;
  createdDate: string;
  id: number;
  shareable: boolean;
  isHidden: false;
  lastUpdated: string;
  name: string;
  parentId: number;
  sharable: boolean;
  socNumber: string;
  version: number;
  standard: any;
};

export interface UpdateQuizParameters {
  quizId: number;
  name: string;
  isSharable: boolean;
  quizUrl: QuizUrl;
}

async function updateQuiz({
  quizId,
  name,
  isSharable,
  quizUrl,
}: UpdateQuizParameters): Promise<UpdateQuizResponse> {
  const url = quizUrl({ quizId });
  const payload = {
    name,
    sharable: isSharable,
  };
  const response = await axios.put<UpdateQuizResponse>(url, payload);
  return response.data;
}

const reorderQuestion = async ({
  quizId,
  questionOrder,
}: {
  quizId: string | number;
  questionOrder: Array<string | number>;
}) => {
  return Promise.resolve({
    quizId,
    questionOrder,
  });
};

export { loadQuiz, updateQuiz, getQuizById, deleteQuiz, reorderQuestion };
